module.exports = __webpack_public_path__ + "img/verena-teks.65422782.png";